import Int32 from './Integers/Int32';
export default function asInt32(value) {
    return new Int32(value);
}
